import { SET_ADDRESSES, SET_EMAIL_ADDRESSES } from "./addressesActions";

export const addresses = (state = {}, action) => {
    switch (action.type) {
        case SET_ADDRESSES:
            return { ...state, addresses: action.addresses };
        case SET_EMAIL_ADDRESSES:
            return { ...state, emailAddresses: action.emailAddresses };
        default:
            return state;
    }
};
